export default "__VITE_PUBLIC_ASSET__81cb29d8__"